export default "__VITE_ASSET__CyKg9d2O__"